import type { FaireProductEntity } from "../../entity_types/product";

export const p_van8jrnudf: FaireProductEntity = {
  token: "p_van8jrnudf",
  type: "product",
  name: "Winter Sparkle Socks (wholesale)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/5709779dfee86d1749d23d24929e536a477514ade09fa4d8f4dcbfc81721b699.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d4337e4db1319a5e3e9730f49e57f4c3cfefd7ba2b45518c3c19c5d5be875d48.jpeg",
    "https://cdn.faire.com/fastly/4f4ffb76a771d2d7c679fef541c4961cfa4634ab09bc4d0b9c674a2f15a77366.jpeg",
    "https://cdn.faire.com/fastly/490b350c724fc1384fbdf1eaac267081ee2d95b0fde03c00dc871b9688f6d1c0.jpeg",
    "https://cdn.faire.com/fastly/40243306f9505bcce0aecccb77fe46a1f025bef2bbd0ebffdc640357edcdc4e9.jpeg",
    "https://cdn.faire.com/fastly/a83c6d19badb437f55fae38cc0503272019e6765a71761ec52d3905b3643961c.jpeg",
    "https://cdn.faire.com/fastly/5d761180f01cc9ebdb4a12345634b0dfa7948658eebed5cd6d42e16b7b12b5ff.jpeg",
    "https://cdn.faire.com/fastly/c5dca839c808fb0ec4a950aadfdc97749f7fd19c0d9394c2f374ddfa315fc5f3.jpeg",
    "https://cdn.faire.com/fastly/7a38ce391e64281d820948ffd7124c83ca12661f65c97f0719efeaa650218f82.jpeg",
    "https://cdn.faire.com/fastly/e24dba9f3b83ddf48fb464c94770804126539d365a727a65afa2575fdef513be.jpeg",
    "https://cdn.faire.com/fastly/632cd7fb8455e0dc58a4d2cc03c061a7beb18b37eff009806f8671e7c04bdaff.jpeg",
    "https://cdn.faire.com/fastly/8b9ae922bf8dbafdfea6bb4fba4acc47f08bfa0557f696abd85818f0d2aa9a12.jpeg",
    "https://cdn.faire.com/fastly/57a77ff80669aa401bb0293b35e8862ab327951416b6e146d53fcfedce288da9.jpeg",
    "https://cdn.faire.com/fastly/b8dac8987c861c37d0ee3a333d441d250fcf08a33f6ae5752b61f496ed121427.jpeg",
    "https://cdn.faire.com/fastly/e6e19380740d01f15293eef441ffcae3ec35d2a9e5bc4be0d91946d995b9bcd4.jpeg",
    "https://cdn.faire.com/fastly/60b910f08cfa795ff8fb299b228c6332a36265fad6ebf8710ff5d3171de011f9.jpeg",
    "https://cdn.faire.com/fastly/2359c0bc7d6ba4825a64163f09897f5bed01fed649bcdc6c1ccfd6e4e02fbdef.jpeg",
    "https://cdn.faire.com/fastly/4c9c06cd4354005eab3a3317fa10bf7b7d1c9eab7fb898fa0e1baeff3d429ec0.jpeg",
    "https://cdn.faire.com/fastly/114a4cdecf1f6d6430c7f1af46e4c246d230936bf9da52b378354a732645d651.jpeg",
    "https://cdn.faire.com/fastly/9d4e8d79a5398c737641270e8886bdc9baaacfe6872b4c18957ba721ec7dbea0.jpeg",
    "https://cdn.faire.com/fastly/1a6d0c6edead44d7531e8e5d111a753a82157a0a9afa19eec5066e0136d58b2f.jpeg",
    "https://cdn.faire.com/fastly/d3d49d01b7c50619f7d8d2f075d84ed6a02d5aee9d0562b3573260e05b14bc29.jpeg",
    "https://cdn.faire.com/fastly/bef93b20f14080eeae2d44db7bde20d883553ce12507663d87ee76055f3bcb99.jpeg",
    "https://cdn.faire.com/fastly/501ac56e1705365777e91e976f891bc70ce9bf0ce7f72a98df7adede94cfb0a5.jpeg",
    "https://cdn.faire.com/fastly/314327e43e65ab7db93625b417f34fc6899b61f700c607063973e4e97ecf6968.jpeg",
    "https://cdn.faire.com/fastly/8b61d6a19f48fa0223bc22206a8488cffe9df04d2e453b4df4003779b627fb81.jpeg",
    "https://cdn.faire.com/fastly/7d9b953bff4bfcc495989c7ba6ccca069408c0518e5ef65d6c5c0ad3f3046779.jpeg",
    "https://cdn.faire.com/fastly/ca16dedadb32684ec174a650ebd35c6b9fcc03952caf41068f1c8bcd720f61f8.jpeg",
    "https://cdn.faire.com/fastly/58353ae96e54664cd47da5c6903e55592f3ced34984ce6cd98801b7a77712042.jpeg",
    "https://cdn.faire.com/fastly/e904e0d4da9c0f3cae16d53a207016a45de5d151d9198a3423b3edd1ef00aa03.jpeg",
  ],
  priceDollars: 9,
  description:
    "𝗪𝗵𝘆 𝗪𝗲 𝗠𝗮𝗱𝗲 𝗧𝗵𝗶𝘀?\n\nNothing says twinkle toes like the Winter Sparkle Socks. Crafted from a cozy wool-Lurex blend, this sparkly version of the Snow Socks is sure to get you through the winter chill in style. The extra length can be worn up for an added layer of warmth or scrunched or folded with your favorite clogs or Mary Janes.\n\nMade in South Korea\n\n𝗖𝗼𝗻𝘁𝗲𝗻𝘁𝘀:\n\nWool 53%, Nylon 25%, Polyester 12%, Silk 4%, Lurex 4%, Spandex 2%\n\n𝗦𝗶𝘇𝗶𝗻𝗴:\n\nOne size fits most (US women's size 6-10)\n\n𝗖𝗮𝗿𝗲 𝗜𝗻𝘀𝘁𝗿𝘂𝗰𝘁𝗶𝗼𝗻𝘀:\n\n• Hand wash cold\n• Line dry\n• Do not iron\n• Do not bleach\n\n***Order in units of 6 (6,12,18,24 etc)\n\nMSRP: $20 USD",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:15.929Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
